import validate from "/Users/lysis/Documents/html/esoteric/app_dir/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}